import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {Lazyload, Toast, Dialog, Notify, ImagePreview, Popup, Picker} from "vant";
import axios from "axios";
import VueAxios from "vue-axios";
import VueClipboard from "vue3-clipboard";
import eventBus from "vue3-eventbus";
const app = createApp(App);
app.use(store).use(router).use(Lazyload, Toast, Dialog, Notify, ImagePreview, Popup, Picker).use(VueAxios, axios).use(eventBus)
  .use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true,
  }).mount("#app");